import { render } from "./agency.vue?vue&type=template&id=15851e8e&ts=true"
import script from "./agency.vue?vue&type=script&lang=ts"
export * from "./agency.vue?vue&type=script&lang=ts"

import "./agency.vue?vue&type=style&index=0&id=15851e8e&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__